import { GetLang, RegisterLang } from '@/api/mu'
import { APP_NAME, APP_VERSION } from '@/config/global.ts'

export const GetLocalLang = async (lang) => {
    if(lang=='zh-cn'){
        lang = 'zh-CN'
    }
    if(lang=='zh-tw'){
        lang = 'zh-TW'
    }         
    const param ={
        langCode:lang,
        withI18nData:true,
        app: APP_NAME,
        version: APP_VERSION
    }
    const res = await GetLang(param)
    if(res?.data?.i18nData){
        return {
          default: res.data.i18nData
        }
    }
    if(lang!='zh-CN'&&lang!='zh-TW'&&lang!='en'){
        lang = 'en'
    }else{
        RegisterLocalLang()
    }
    const langObj = await import(`../locales/${lang}.ts`)
    return langObj
}

export const RegisterLocalLang = async()=>{
    const cnObj = await import(`../locales/zh-CN.ts`)
    const twObj = await import(`../locales/zh-TW.ts`)
    const enObj = await import(`../locales/en.ts`)
    const params = {
        service: APP_NAME,
        version: APP_VERSION,
        builtinI18nData: [
            {
                langCode:'zh-CN',
                i18nData:cnObj.default ?? {}
            },
            {
                langCode:'zh-TW',
                i18nData:twObj.default ?? {}
            },
            {
                langCode:'en',
                i18nData:enObj.default ?? {}
            }
        ] 
    }
    return await RegisterLang(params)
}

